import { vec3 } from "gl-matrix";
import { ShaderManager } from "../ShaderManager";
import { TextureManager } from "../TextureManager";
import { RenderObject, RenderObjectConstructorArgs } from "./RenderObject";
import { Material, ObjectType } from "./types";

export type PlaneInitArgs = {
  material?: Material;
} & RenderObjectConstructorArgs;

// TODO - support scaling plane (scaling uvs etc)
export class Plane extends RenderObject {
  constructor(args: PlaneInitArgs) {
    super(args);
    this.type = ObjectType.PLANE;

    if (args.material) {
      this.material = args.material;
    }
    // TODO - should I just add vertices/triangles so backface culling doesn't remove it when "below"
    this.model.vertices = [0.0, 0.5, 0.5, 0.0, 0.5, 0.0, 0.5, 0.5, 0.0, 0.5, 0.5, 0.5];
    this.model.triangles = [0, 2, 1, 2, 0, 3];
    this.model.uvs = [0.0, 0.0, 5.0, 0.0, 5.0, 5.0, 0.0, 5.0];
    this.model.normals = [0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0];
  }

  scaleUVs(uvs: number[], scaleVec: vec3) {
    let newUVs = [];

    for (let i = 0; i < uvs.length; i++) {
      if (i % 2 === 0) {
        newUVs.push(uvs[i] * (scaleVec[0] / vec3.len(scaleVec)));
      } else {
        newUVs.push(uvs[i] * (scaleVec[2] / vec3.len(scaleVec)));
      }
    }
    return newUVs;
  }

  setup(gl: WebGL2RenderingContext, shaderManager: ShaderManager, textureManager: TextureManager) {
    if (this.material) {
      this.material.diffuseTexture = textureManager.getTexture(this.material.diffuseTexture?.name);
      this.material.normalTexture = textureManager.getTexture(this.material.normalTexture?.name, "normal");
    }

    const tangentData = this.calculateBitangents();
    this.model.bitangents = tangentData.bitangents.flat();
    this.model.tangents = tangentData.tangents.flat();
    this.calculateCentroid(this.model.vertices);
    this.initShader(gl, shaderManager);
    this.initBuffers(gl);
  }

  clone(name: string): Plane {
    return new Plane({
      name,
      position: this.model.position,
      scale: this.model.scale,
      rotation: this.model.rotation,
      diffuseTextureFile: this.material?.diffuseTexture?.name,
      normalTextureFile: this.material?.normalTexture?.name,
      material: this.material,
    });
  }
}
